"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkIUCGFBDZ_js = require('./chunk-IUCGFBDZ.js');
var chunkUUN3IUQ2_js = require('./chunk-UUN3IUQ2.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var l = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');
var faArrowDown = require('@fortawesome/free-solid-svg-icons/faArrowDown');
var faArrowUp = require('@fortawesome/free-solid-svg-icons/faArrowUp');
var react = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var l__default = /*#__PURE__*/_interopDefaultLegacy(l);

var u=l__default["default"].table`
  --background-level-1: var(--color-neutral-0);
  --border-default: var(--color-neutral-200);
  --border-table-active: var(--color-neutral-700);

  background: var(--background-level-1);
  border-collapse: collapse;
  color: var(--color-neutral-700);
  font-size: var(--font-size-regular);
  width: 100%;
`,g=l__default["default"].thead`
  color: var(--color-neutral-800);
`,C=l__default["default"].td`
  border-bottom: var(--border-width-x-small) solid var(--border-default);
  vertical-align: middle;
  overflow-wrap: anywhere;

  ${({xAlign:o})=>o&&{"text-align":o}}
  ${({yAlign:o})=>o&&{"vertical-align":o}}
  ${({$spacing:o})=>o&&{padding:`var(--spacing-${o}) var(--spacing-regular);`}}

  @media print {
    white-space: normal;
  }
`,x=l__default["default"].th`
  border-bottom: var(--border-width-x-small) solid var(--border-default);
  font-weight: var(--font-weight-bold);
  padding: var(--spacing-large) var(--spacing-regular) var(--spacing-small)
    var(--spacing-regular);

  ${({yAlign:o})=>o&&{"vertical-align":o}}

  ${({$sortable:o})=>o&&`
      cursor: pointer;

      &:hover {
        background: var(--color-neutral-50);
      }
      `}

    ${({$sortable:o,$sortDirection:t})=>o&&t&&`
      border-bottom: var(--border-width-small) solid var(--border-table-active);
      }
    `}

    @media print {
    width: auto;
  }
`,P=l__default["default"].span`
  flex: 1;
  display: flex;
  justify-content: center;

  ${({xAlign:o})=>o&&{"justify-content":o}}
`,v=l__default["default"](chunkUUN3IUQ2_js.a).attrs({spacing:"small",xAlign:"space-between",yAlign:"center"})`
  overflow-wrap: anywhere;
`,D=l__default["default"].tr`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: absolute;

  ::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.5;
    background-color: var(--background-level-1);
    z-index: 0;
  }
`,A=l__default["default"].tbody`
  position: relative;
`;var L=({children:o,...t})=>jsxRuntime.jsx(u,{...t,children:o});var H=({children:o,...t})=>jsxRuntime.jsx(g,{...t,children:o});var w=({children:o,...t})=>jsxRuntime.jsx(A,{...t,children:o});var M=({children:o,...t})=>jsxRuntime.jsx("tfoot",{...t,children:o});var K=({children:o,...t})=>jsxRuntime.jsx("tr",{...t,children:o});var d=({xAlign:o="left",yAlign:t="middle",spacing:p="regular",children:i,...r})=>jsxRuntime.jsx(C,{xAlign:o,yAlign:t,$spacing:p,...r,children:i});var B={ASC:faArrowUp.faArrowUp,DESC:faArrowDown.faArrowDown},G={ASC:"ascending",DESC:"descending"},R=({xAlign:o="left",yAlign:t="middle",children:p,sortable:i=!1,sortDirection:r,...s})=>jsxRuntime.jsx(x,{$sortable:i,$sortDirection:r,yAlign:t,"aria-sort":r?G[r]:"none",...s,children:jsxRuntime.jsxs(v,{children:[jsxRuntime.jsx(P,{xAlign:o,children:p}),r&&jsxRuntime.jsx(chunkLXX3SSRV_js.a,{size:"small",icon:B[r]})]})});var W=()=>jsxRuntime.jsx(D,{children:jsxRuntime.jsx(d,{"aria-label":"loading spinner",children:jsxRuntime.jsx(chunkIUCGFBDZ_js.a,{})})});var _={Root:l__default["default"](L)``,Thead:l__default["default"](H)``,Tbody:l__default["default"](w)``,Tfoot:l__default["default"](M)``,Tr:l__default["default"](K)``,Td:l__default["default"](d)``,Th:l__default["default"](R)``,LoadingSpinner:l__default["default"](W)``};var J=(o,t,p,i)=>{let[{sortKey:r,sortDirection:s},c]=react.useState({sortKey:t,sortDirection:o}),b=e=>{let n=e.indexOf(s);return e[(n+1)%e.length]};return {sortKey:r,sortDirection:s,sortColumn:(e,n)=>{if(e===r){let h=b(p);c({sortKey:e,sortDirection:h}),i==null||i(e,h);return}c({sortKey:e,sortDirection:n!=null?n:o}),i==null||i(e,n!=null?n:o);},getColumnSortDirection:e=>r===e?s:void 0,getNextSortDirection:b}};

exports.a = _;
exports.b = J;
